import { FlowConfig } from '../types';

export const pcFlowConfig: FlowConfig = {
  step1: {
    path: '/pdp-config',
    requirements: [],
  },
  step2: {
    path: '/new-page-before-summary',
    requirements: [],
  },
  step3: {
    path: '/cart',
    requirements: [],
  },
  step4: {
    path: '/tenant-selector',
    private: true,
    requirements: ['hasMoreThanOneTenant'],
  },
  step5: {
    path: '/claim',
    private: true,
    requirements: ['redirectToClaim'],
  },
  step6: {
    path: '/checkout',
    private: true,
    requirements: [],
  },
  step7: {
    path: '/review-subscription',
    requirements: ['hasIISubscription'],
    private: true,
    relativePath: true,
  },
  step8: {
    path: '/order',
    private: true,
    requirements: [],
  },
};
